import { render, staticRenderFns } from "./MyPoint.vue?vue&type=template&id=a384eeae&scoped=true&"
import script from "./MyPoint.vue?vue&type=script&lang=js&"
export * from "./MyPoint.vue?vue&type=script&lang=js&"
import style0 from "./MyPoint.vue?vue&type=style&index=0&id=a384eeae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a384eeae",
  null
  
)

export default component.exports